import { TFunction } from "i18next";

import { toast } from "@4pace-cpq/core";

export async function exportQuoteToExcel(
  materialNumber: string,
  country: string,
  language: string,
  t: TFunction,
): Promise<void> {
  try {
    const response = await fetch(
      `/api/Downloads/DownloadDataSheet?materialNumber=${materialNumber}&country=${country}&language=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (!response.ok) {
      console.log({ response });
      const data = await response.json();
      if (response.status === 409) {
        showErrorToast(t(`WEG:${data.key}`, { params: data.params }));
        window.open(data.returnValue, "_blank");
        return;
      }
      showErrorToast(t(`WEG:${data.key}`, { params: data.params }));
      throw new Error(
        "There is something wrong with the response: " + response.statusText,
      );
    }

    // Extract filename from Content-Disposition header
    let fileName = `Test.pdf`; // Default file name
    const contentDisposition = response.headers.get("Content-Disposition");
    console.log(contentDisposition);

    if (contentDisposition) {
      fileName =
        contentDisposition
          ?.split(";")
          ?.find((n) => n.includes("filename="))
          ?.replace(/filename=|"|'/g, "")
          .trim() || fileName;
    }

    // Create a Blob from the response
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element for downloading
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName; // Set the file name from Content-Disposition or default
    document.body.appendChild(a);
    a.click();

    // Clean up and remove the anchor element after download
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error:", error); // Handle errors
  }
}

export function showErrorToast(errorMessage: string): void {
  toast.error(errorMessage, {
    autoClose: 30000,
  });
}
